// removed by extract-text-webpack-plugin
module.exports = {"Container":"toolTip__Container__1ORt7","ToolTipText":"toolTip__ToolTipText__34UuA","Green":"toolTip__Green__3O8Px toolTip__ToolTipText__34UuA"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ToolTip/toolTip.css
// module id = 857
// module chunks = 2